import React, { useEffect } from 'react';

const InstagramWidget = () => {
  useEffect(() => {
    // Dynamically add the Elfsight platform script
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup to remove the script if the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  return (
    <div>
      {/* Include the Elfsight widget div */}
      <div
        className="elfsight-app-1db62146-8b04-4bf4-813d-7c393424b468"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
};

export default InstagramWidget;
